import { createAction } from 'typesafe-actions';

import { RSState } from '../types';

export const putRS = createAction('rs/put_rs')<RSState>();
